import u from '../utils/index';

document.querySelectorAll('[data-switch-line-ellipsis]').forEach(el => {
  if (el.scrollHeight === el.clientHeight) return;
  el.style.cursor = 'pointer';
  el.addEventListener('click', function () {
    u.setCssVar(el, {
      'line-clamp': el.scrollHeight === el.clientHeight ? '' : 0,
    });
  });
});
